import { SwitchButton } from "components/switchButton";
import { IPasscodeItem } from "interfaces";
import { TooltipParagraph } from "components/tooltipParagraph";
import { get } from "lodash";
import moment from "moment";
import { HistoryLogButton } from "components/historyLogButton";
import { isHaveActionPermission } from "utills/helpers";
import { PRIVATE_FLOW_TYPES } from "utills/constants";

interface PasscodeTableProps {
  data?: IPasscodeItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

const getPrivateFlowTypeLabel = (value?: string) =>
  PRIVATE_FLOW_TYPES.find((type) => type.value === value)?.label || "";

export const PasscodeTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: PasscodeTableProps) => {
  return (
    <div className="flow-root w-full">
      <div className="relative w-full overflow-x-auto align-middle box-border">
        <table className="table-auto w-max min-w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Passcode/Email Address
              </th>
              <th scope="col" className="th">
                Event name
              </th>
              <th scope="col" className="th">
                Private Flow Type
              </th>
              <th scope="col" className="th">
                Used Count
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th">
                Created at/by
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IPasscodeItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td font-medium">
                  {item.auth_identifier}
                </td>
                <td className="td max-w-20 overflow-x-auto">
                  <TooltipParagraph 
                    text={get(item, "event_name_en", "")}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td">
                  {getPrivateFlowTypeLabel(get(item, "private_flow_type", ""))}
                </td>
                <td className="td">
                  {item.usage_count}/{item.max_usage_count}
                </td>
                <td className="td">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("private_code_email", "events", "edit")}
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td">
                  <p>
                    {item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ""}
                  </p>
                  <p>
                    {item.created_by}
                  </p>
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <HistoryLogButton 
                    className="!w-8 !h-8 border-none text-black p-0 bg-gray-200 hover:bg-gray-200 active:bg-gray-300"
                    resource={`private-flow/event-passcodes/${item.id}/history`}
                    hideTitle
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
